import React, { useState, useEffect } from "react";
import {
  Button,
  Input,
  Checkbox,
  Select,
  SelectItem,
  Alert,
  form,
} from "@heroui/react";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
} from "@heroui/react";

const MatchForm = ({
  formData,
  setFormData,
  onSubmit,
  onCancel,
  setShowForm,
  getMatches,
  matchData,
  matchDetails,
  setMatchDetails,
  marketData,
  originalMatchDetails,
}) => {
  const [selectedRows, setSelectedRows] = useState({
    row1: false,
    row2: false,
    row3: false,
    row4: false,
    row5: false,
    // Add more rows as needed
  });

  const [selectAll, setSelectAll] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openH, openM] = formData.open_time.split(":").map(Number);
  const [closeH, closeM] = formData.close_time.split(":").map(Number);

  const openMinutes = openH * 60 + openM;
  const closeMinutes = closeH * 60 + closeM;

  // In add mode, default to select-all checked with default values populated
  useEffect(() => {
    if (!formData?.id && !selectAll) {
      setSelectAll(true);
      setMatchDetails((prev) => {
        const defaultRates = {
          row1: "9.5",
          row2: "125.00",
          row3: "250.00",
          row4: "900.00",
          row5: "90.00",
        };
        const updated = { ...prev };
        Object.keys(updated).forEach((key) => {
          const row = updated[key] || {};
          updated[key] = {
            ...row,
            selected: true,
            rate:
              row.rate && row.rate.toString().trim() !== ""
                ? row.rate
                : defaultRates[key] || row.rate || "",
            min_stake:
              row.min_stake && row.min_stake.toString().trim() !== ""
                ? row.min_stake
                : "10",
            max_stake:
              row.max_stake && row.max_stake.toString().trim() !== ""
                ? row.max_stake
                : "2000",
          };
        });
        return updated;
      });
    }
  }, [formData?.id, selectAll, setMatchDetails]);

  const handleRowCheckboxChange = (rowKey, isChecked) => {
    setSelectedRows((prev) => ({ ...prev, [rowKey]: isChecked }));
  };

const handleInputChange = (e) => {
  let { name, value } = e.target;
 
  if (name === "name") {
    const alphaOnly = /^[A-Za-z ]*$/;
    if (!alphaOnly.test(value)) return;
 
    // Optional: collapse multiple spaces
    value = value.replace(/\s+/g, ' ');
  }
 
  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};
  const handleActiveChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      is_active: selected ? 1 : 0,
    }));
  };
  const handleOpenActive = (selected) => {
    setFormData((prev) => ({
      ...prev,
      open_suspend: selected ? 1 : 0,
    }));
  };
  const handleCloseActive = (selected) => {
    setFormData((prev) => ({
      ...prev,
      close_suspend: selected ? 1 : 0,
    }));
  };

  const handleMatchTypeChange = (rowKey, field, value) => {
    // const numericOnly = /^[0-9]*$/;
    const numericOnly = /^(\d+(\.\d*)?)?$/;
    if (!numericOnly.test(value)) return; //
    const newMatchDetails = {
      ...matchDetails,
      [rowKey]: {
        ...matchDetails[rowKey],
        [field]: value,
      },
    };
    setMatchDetails(newMatchDetails);
    // console.log("Updated matchDetails:", newMatchDetails);
  };

  const handleCheckboxChange = (rowKey, isChecked) => {
    // In add mode, ignore individual checkbox changes; use select-all instead
    if (!formData?.id) {
      return;
    }
    setMatchDetails((prev) => {
      const previousRow = prev?.[rowKey] || {};
      let updatedRow = { ...previousRow, selected: isChecked };

      // Only auto-populate/clear in Add mode
      if (!formData?.id) {
        if (isChecked && !previousRow.selected) {
          const defaultRates = {
            row1: "9.5",
            row2: "125.00",
            row3: "250.00",
            row4: "900.00",
            row5: "90.00",
          };
          if (!updatedRow.rate || updatedRow.rate.toString().trim() === "") {
            updatedRow.rate = defaultRates[rowKey] || updatedRow.rate || "";
          }
          if (!updatedRow.min_stake || updatedRow.min_stake.toString().trim() === "") {
            updatedRow.min_stake = "10";
          }
          if (!updatedRow.max_stake || updatedRow.max_stake.toString().trim() === "") {
            updatedRow.max_stake = "2000";
          }
        }

        // If unchecked, clear displayed values
        if (!isChecked) {
          updatedRow = {
            ...updatedRow,
            rate: "",
            min_stake: "",
            max_stake: "",
          };
        }
      }

      return { ...prev, [rowKey]: updatedRow };
    });
  };

  const handleSelectAllChange = (isSelected) => {
    setSelectAll(isSelected);
    if (!formData?.id) {
      setMatchDetails((prev) => {
        const defaultRates = {
          row1: "9.5",
          row2: "125.00",
          row3: "250.00",
          row4: "900.00",
          row5: "90.00",
        };
        const newDetails = {};
        Object.keys(prev).forEach((key) => {
          const row = prev[key] || {};
          if (isSelected) {
            newDetails[key] = {
              ...row,
              selected: true,
              rate:
                row.rate && row.rate.toString().trim() !== ""
                  ? row.rate
                  : defaultRates[key] || row.rate || "",
              min_stake:
                row.min_stake && row.min_stake.toString().trim() !== ""
                  ? row.min_stake
                  : "10",
              max_stake:
                row.max_stake && row.max_stake.toString().trim() !== ""
                  ? row.max_stake
                  : "2000",
            };
          } else {
            newDetails[key] = {
              ...row,
              selected: false,
              rate: "",
              min_stake: "",
              max_stake: "",
            };
          }
        });
        return newDetails;
      });
    } else {
      const newDetails = {};
      Object.keys(matchDetails).forEach((key) => {
        newDetails[key] = { ...matchDetails[key], selected: isSelected };
      });
      setMatchDetails(newDetails);
    }
  };
  const handleSubmit = async (e) => {
    try {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));
      const token = localStorage.getItem("jwt");
      const userId = localStorage.getItem("uid");
      if (!formData.marketId || formData.marketId.trim() === "") {
        setErrorMessage("Please select a market.");
        setShowErrorAlert(true);
        return;
      }
      if (!formData.name || formData.name.trim() === "") {
        setErrorMessage("Please enter match name.");
        setShowErrorAlert(true);
        return;
      }
      if (!formData.draw_date) {
        setErrorMessage("Please select draw date.");
        setShowErrorAlert(true);
        return;
      }
      if (!formData.open_time || !formData.close_time) {
        setErrorMessage("Please provide both open and close time.");
        setShowErrorAlert(true);
        return;
      }
      if (closeMinutes < openMinutes) {
        setErrorMessage("Close Time must be less than Open Time.");
        setShowErrorAlert(true);
        return;
      }

      const convertedMatchTypes = Object.values(matchDetails)
        .filter(
          (row) =>
            row.selected &&
            row.rate.trim() !== "" &&
            row.min_stake.trim() !== "" &&
            row.max_stake.trim() !== ""
        )
        .map((row) => ({
          type_id: row.type_id,
          rate: Number(row.rate),
          min_stake: Number(row.min_stake),
          max_stake: Number(row.max_stake),
        }));
      // console.log(convertedMatchTypes);
      if (convertedMatchTypes.length === 0) {
        setErrorMessage("Please fill the Match types.");
        setShowErrorAlert(true);
        return;
      }

      const row1 = matchDetails?.row1;

      const isRow1Valid =
        row1 &&
        row1.selected &&
        row1.rate?.toString().trim() !== "" &&
        row1.min_stake?.toString().trim() !== "" &&
        row1.max_stake?.toString().trim() !== "";

      if (!isRow1Valid) {
        setErrorMessage("Please fill the Single Match type (Row 1).");
        setShowErrorAlert(true);
        return;
      }

      const rowNames = [
        "Single",
        "Single Patti",
        "Double Patti",
        "Triple Patti",
        "Jodi",
      ];
      const rows = [
        matchDetails?.row1,
        matchDetails?.row2,
        matchDetails?.row3,
        matchDetails?.row4,
        matchDetails?.row5,
      ];

      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const rowName = rowNames[i];

        if (row && row.selected) {
          const rate = Number(row.rate?.toString().trim());
          const minStake = Number(row.min_stake?.toString().trim());
          const maxStake = Number(row.max_stake?.toString().trim());

          if (isNaN(rate) || rate < 1) {
            setErrorMessage(
              `Row ${rowName}: Please provide a valid rate (should be greater than 0)`
            );
            setShowErrorAlert(true);
            return;
          }

          if (isNaN(minStake) || minStake < 10) {
            setErrorMessage(
              `Row ${rowName}: Please provide a valid Min Stake (minimum 10)`
            );
            setShowErrorAlert(true);
            return;
          }

          if (isNaN(maxStake) || maxStake < 10) {
            setErrorMessage(
              `Row ${rowName}: Please provide a valid Max Stake (minimum 10)`
            );
            setShowErrorAlert(true);
            return;
          }
        }
      }

      const payload = {
        user_id: userId,
        market_id: formData.marketId,
        name: formData.name,
        draw_date: formData.draw_date,
        open_time: formData.open_time,
        close_time: formData.close_time,
        open_suspend: formData.open_suspend === "open_suspended" ? 1 : 0,
        close_suspend: formData.close_suspend === "close_suspended" ? 1 : 0,
        is_active: formData.is_active ? 1 : 0,
        match_types: convertedMatchTypes,
      };
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/addmatch`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      if (response.status === 200 && data.success) {
        setAlertMessage("Match added successfully!");
        setShowAlert(true);
        setShowErrorAlert(false);
        setTimeout(() => {
          setShowForm(false);
          getMatches(); // reload match list
        }, 2000);
      } else if (response.status === 400) {
        setErrorMessage(data.message);
        setShowErrorAlert(true);
      } else {
        throw new Error(data.message || "Failed to add match");
      }
    } catch (error) {
      console.error("Add Match Error:", error);
      setErrorMessage("Something went wrong");
      setShowErrorAlert(true);
    }
  };

  const formatDateForInput = (dateString) => {
    return dateString?.split("T")[0]; // returns '2025-06-05'
  };
  const handleUpdateMatch = async (e) => {
    try {
            if (
        !formData.name?.trim() ||
        !formData.marketId ||
        !formData.draw_date ||
        !formData.open_time ||
        !formData.close_time
      ) {
        alert("Please fill all required match fields.");
        return;
      }

      const rowNames = [
        "Single",
        "Single Patti",
        "Double Patti",
        "Triple Patti",
        "Jodi",
      ];
      const rows = [
        matchDetails?.row1,
        matchDetails?.row2,
        matchDetails?.row3,
        matchDetails?.row4,
        matchDetails?.row5,
      ];

      const convertedMatchTypes = [];

      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const rowName = rowNames[i];

        if (row?.selected) {
          const rate = Number(row.rate?.toString().trim());
          const minStake = Number(row.min_stake?.toString().trim());
          const maxStake = Number(row.max_stake?.toString().trim());

          if (isNaN(rate) || rate < 1) {
            setErrorMessage(
              `Row ${rowName}: Please provide a valid rate (should be greater than 0)`
            );
            setShowErrorAlert(true);
            return;
          }

          if (isNaN(minStake) || minStake < 10) {
            setErrorMessage(
              `Row ${rowName}: Please provide a valid Min Stake (minimum 10)`
            );
            setShowErrorAlert(true);
            return;
          }

          if (isNaN(maxStake) || maxStake < 10) {
            setErrorMessage(
              `Row ${rowName}: Please provide a valid Max Stake (minimum 10)`
            );
            setShowErrorAlert(true);
            return;
          }
          if (closeMinutes < openMinutes) {
            setErrorMessage("Close Time must be less than Open Time.");
            setShowErrorAlert(true);
            return;
          }

          // Add to convertedMatchTypes
          convertedMatchTypes.push({
            type_id: row.type_id,
            rate,
            min_stake: minStake,
            max_stake: maxStake,
          });
        }
      }
      if (convertedMatchTypes.length === 0) {
        setErrorMessage("Please fill at least one Match type.");
        setShowErrorAlert(true);
        return;
      }

      let token = localStorage.getItem("jwt");
      formData.user_id = localStorage.getItem("uid");
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/editmatch/${formData.id}`,
        {
          method: "POST",
          // let headers = new Headers();
          // headers.append("Content-Type", "application/json");
          // headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            id: formData.id,
            user_id: formData.user_id,
            market_id: formData.marketId,
            name: formData.name,
            draw_date: formData.draw_date,
            open_time: formData.open_time,
            close_time: formData.close_time,
            is_active: formData.is_active ? 1 : 0,
            open_suspend: formData.open_suspend === "open_suspended" ? 1 : 0,
            close_suspend: formData.close_suspend === "close_suspended" ? 1 : 0,
            match_types: convertedMatchTypes,
          }),
        }
      );
      if (response.status === 200) {
        const data = await response.json();
        // Show success popup — you can use alert or better UI dialog
        // alert("Match updated successfully!");
        setAlertMessage("Match updated successfully");
        setShowAlert(true);

        // Call getMatches() to refresh the list (make sure getMatches is in scope)
        setTimeout(() => {
          getMatches(); // reload match list
          setShowForm(false);
        }, 800);
      } else if (response.status === 400) {
        setErrorMessage("Match with same name and  date already exists");
        setShowErrorAlert(true);
      }
    } catch (error) {
      console.error("Error updating match:", error);
    }
  };

  return (
    <div className="bg-white shadow rounded-lg p-6 mb-6">
      {showAlert && (
        <Alert
          color="success"
          className="mb-4"
          onClose={() => setShowAlert(false)}
        >
          {alertMessage}
        </Alert>
      )}
      {showErrorAlert && (
        <Alert
          color="danger"
          className="mb-4"
          onClose={() => setShowErrorAlert(false)}
        >
          {errorMessage}
        </Alert>
      )}
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        {formData.id ? "Edit Match" : "Add New Match"}
      </h3>
      <form className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Market Name <span className="text-red-500">*</span>
            </label>
            <Select
              selectedKeys={[String(formData.marketId)]} // ensure string key
              onSelectionChange={(keys) => {
                const selectedId = [...keys][0];
                const selectedMarket = marketData.find(
                  (m) => String(m.id) === selectedId
                );

                setFormData((prev) => ({
                  ...prev,
                  marketId: selectedId,
                  marketname: selectedMarket?.name || "",
                }));
              }}
              placeholder="Select Market"
            >
              {marketData
                ?.filter((market) => {
                  const isDeleted = market.is_deleted?.data?.[0] ?? 0;
                  return isDeleted === 0;
                })
                .map((market) => (
                  <SelectItem key={market.id} value={String(market.id)}>
                    {market.name}
                  </SelectItem>
                ))}
            </Select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Match Name <span className="text-red-500">*</span>
            </label>
            <Input
              type="text"
              name="name"
              value={formData?.name}
              onChange={handleInputChange}
              placeholder="Enter Match name"
              className="border border-gray-300 rounded-xl"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Draw Date <span className="text-red-500">*</span>
            </label>
            <Input
              type="date"
              name="draw_date"
              value={formatDateForInput(formData.draw_date)}
              // value={formData.draw_dater}
              onChange={handleInputChange}
              className="border border-gray-300 rounded-xl"
              min={new Date().toISOString().split("T")[0]}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Is Match Active
            </label>
            <Checkbox
              isSelected={formData.is_active}
              onChange={() => {
                setFormData((prev) => ({
                  ...prev,
                  is_active: !prev.is_active,
                }));
              }}
              size="md"
              color="success"
            >
              {formData.is_active ? "Active" : "Active"}
            </Checkbox>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Open Time <span className="text-red-500">*</span>
            </label>
            <Input
              type="time"
              name="open_time"
              value={formData.open_time}
              onChange={handleInputChange}
              className="border border-gray-300 rounded-xl"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Is Open Suspend
            </label>

            <Checkbox
              isSelected={formData?.open_suspend == "open_suspended"}
              // onValueChange={handleOpenActive}
              onChange={() => {
                setFormData((prev) => ({
                  ...prev,
                  open_suspend:
                    formData.open_suspend === "open_suspended"
                      ? ""
                      : "open_suspended",
                }));
              }}
              size="md"
              name="open_suspend"
              color="success"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Close Time <span className="text-red-500">*</span>
            </label>
            <Input
              type="time"
              name="close_time"
              value={formData.close_time}
              onChange={handleInputChange}
              className="border border-gray-300 rounded-xl"
              required
              disabled={!formData.open_time}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Is Close Suspend
            </label>
            <Checkbox
              isSelected={formData?.close_suspend == "close_suspended"}
              // onValueChange={handleOpenActive}
              onChange={() => {
                setFormData((prev) => ({
                  ...prev,
                  close_suspend:
                    formData.close_suspend === "close_suspended"
                      ? ""
                      : "close_suspended",
                }));
              }}
              size="md"
              name="open_suspend"
              color="success"
            />
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 overflow-y-auto">
            <thead className="text-xs text-black1 bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="p-4">
                  <div className="flex items-center">
                    {" "}
                    <Checkbox
                      color="success"
                      isSelected={selectAll}
                      isDisabled={!!formData?.id}
                      onChange={(e) => handleSelectAllChange(e.target.checked)}
                    />
                    Select
                  </div>
                </th>
                <th scope="col" className="px-6 py-3">
                  Match Type
                </th>
                <th scope="col" className="px-6 py-3">
                  Rate
                </th>
                <th scope="col" className="px-6 py-3">
                  Min Stake
                </th>
                <th scope="col" className="px-6 py-3">
                  Max Stake
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200 gap-1">
                <td className="w-4 p-4">
                  <div className="flex items-center">
                    <Checkbox
                      color="success"
                      isSelected={matchDetails?.row1?.selected}
                      isDisabled={true}
                      onChange={(e) =>
                        handleCheckboxChange("row1", e.target.checked)
                      }
                    />
                  </div>
                </td>
                <th>Single</th>
                <td className="px-4">
                  {
                    <Input
                      type="text"
                      placeholder="Enter Rate"
                      name="single_rate"
                      size="sm"
                      variant="bordered"
                      className="w-36 sm:w-full"
                      value={matchDetails?.row1?.rate}
                      
                      readOnly={matchDetails?.row1?.isReadOnly}
                      disabled={!matchDetails?.row1?.selected}
                      onChange={(e) =>
                        handleMatchTypeChange("row1", "rate", e.target.value)
                      }
                    />
                  }
                </td>
                <td className="px-4">
                  <Input
                    type="text"
                    placeholder="Enter Min Stake"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row1?.min_stake}
                    readOnly={matchDetails?.row1?.isReadOnly}
                    disabled={!matchDetails?.row1?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row1", "min_stake", e.target.value)
                    }
                  />
                </td>
                <td>
                  <Input
                    type="text"
                    placeholder="Enter Max Stake"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row1?.max_stake}
                    readOnly={matchDetails?.row1?.isReadOnly}
                    disabled={!matchDetails?.row1?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row1", "max_stake", e.target.value)
                    }
                  />
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200 gap-1">
                <td className="w-4 p-4">
                  <div className="flex items-center">
                    <Checkbox
                      color="success"
                      isSelected={matchDetails?.row2?.selected}
                      isDisabled={true}
                      onChange={(e) =>
                        handleCheckboxChange("row2", e.target.checked)
                      }
                    />
                  </div>
                </td>
                <th>Single Patti</th>
                <td className="px-4">
                  <Input
                    type="text"
                    placeholder="Enter Rate"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row2?.rate}
                    readOnly={matchDetails?.row2?.isReadOnly}
                    disabled={!matchDetails?.row2?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row2", "rate", e.target.value)
                    }
                  />
                </td>
                <td className="px-4">
                  <Input
                    type="text"
                    placeholder="Enter Min Stake"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row2?.min_stake}
                    readOnly={matchDetails?.row2?.isReadOnly}
                    disabled={!matchDetails?.row2?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row2", "min_stake", e.target.value)
                    }
                  />
                </td>
                <td>
                  <Input
                    type="text"
                    placeholder="Enter Max Stake"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row2?.max_stake}
                    disabled={!matchDetails?.row2?.selected}
                    readOnly={matchDetails?.row2?.isReadOnly}
                    onChange={(e) =>
                      handleMatchTypeChange("row2", "max_stake", e.target.value)
                    }
                  />
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200 gap-1">
                <td className="w-4 p-4">
                  <div className="flex items-center">
                    <Checkbox
                      color="success"
                      isSelected={matchDetails?.row3?.selected}
                      isDisabled={true}
                      onChange={(e) =>
                        handleCheckboxChange("row3", e.target.checked)
                      }
                    />
                  </div>
                </td>
                <th>Double Patti</th>
                <td className="px-4">
                  <Input
                    type="text"
                    placeholder="Enter Rate"
                    name="double_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row3?.rate}
                    readOnly={matchDetails?.row3?.isReadOnly}
                    disabled={!matchDetails?.row3?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row3", "rate", e.target.value)
                    }
                  />
                </td>
                <td className="px-4">
                  <Input
                    type="text"
                    placeholder="Enter Min Stake"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row3?.min_stake}
                    readOnly={matchDetails?.row3?.isReadOnly}
                    disabled={!matchDetails?.row3?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row3", "min_stake", e.target.value)
                    }
                  />
                </td>
                <td>
                  <Input
                    type="text"
                    placeholder="Enter Max Stake"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row3?.max_stake}
                    readOnly={matchDetails?.row3?.isReadOnly}
                    disabled={!matchDetails?.row3?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row3", "max_stake", e.target.value)
                    }
                  />
                </td>
              </tr>

              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200 gap-1">
                <td className="w-4 p-4">
                  <div className="flex items-center">
                    <Checkbox
                      color="success"
                      isSelected={matchDetails?.row4?.selected}
                      isDisabled={true}
                      onChange={(e) =>
                        handleCheckboxChange("row4", e.target.checked)
                      }
                    />
                  </div>
                </td>
                <th>Tripple Patti</th>
                <td className="px-4">
                  <Input
                    type="text"
                    placeholder="Enter Rate"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row4?.rate}
                    readOnly={matchDetails?.row4?.isReadOnly}
                    disabled={!matchDetails?.row4?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row4", "rate", e.target.value)
                    }
                  />
                </td>
                <td className="px-4">
                  <Input
                    type="text"
                    placeholder="Enter Min Stake"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row4?.min_stake}
                    readOnly={matchDetails?.row4?.isReadOnly}
                    disabled={!matchDetails?.row4?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row4", "min_stake", e.target.value)
                    }
                  />
                </td>
                <td>
                  <Input
                    type="text"
                    placeholder="Enter Max Stake"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row4?.max_stake}
                    readOnly={matchDetails?.row4?.isReadOnly}
                    disabled={!matchDetails?.row4?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row4", "max_stake", e.target.value)
                    }
                  />
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200 gap-1">
                <td className="w-4 p-4">
                  <div className="flex items-center">
                    <Checkbox
                      color="success"
                      isSelected={matchDetails?.row5?.selected}
                      isDisabled={true}
                      onChange={(e) =>
                        handleCheckboxChange("row5", e.target.checked)
                      }
                    />
                  </div>
                </td>
                <th>Jodi</th>
                <td className="px-4">
                  <Input
                    type="text"
                    placeholder="Enter Rate"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row5?.rate}
                    readOnly={matchDetails?.row5?.isReadOnly}
                    disabled={!matchDetails?.row5?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row5", "rate", e.target.value)
                    }
                  />
                </td>
                <td className="px-4">
                  <Input
                    type="text"
                    placeholder="Enter Min Stake"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row5?.min_stake}
                    readOnly={matchDetails?.row5?.isReadOnly}
                    disabled={!matchDetails?.row5?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row5", "min_stake", e.target.value)
                    }
                  />
                </td>
                <td>
                  <Input
                    type="text"
                    placeholder="Enter Max Stake"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 md:w-full"
                    value={matchDetails?.row5?.max_stake}
                    readOnly={matchDetails?.row5?.isReadOnly}
                    disabled={!matchDetails?.row5?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row5", "max_stake", e.target.value)
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* <Table selectionMode="none">
          <TableHeader>
            <TableColumn>
              {" "}
              <Checkbox
                color="success"
                isSelected={selectAll}
                onChange={(e) => handleSelectAllChange(e.target.checked)}
              />
              Select
            </TableColumn>
            <TableColumn>Match Type</TableColumn>
            <TableColumn>Rate</TableColumn>
            <TableColumn>Min Stake</TableColumn>
            <TableColumn>Max Stake</TableColumn>
          </TableHeader>
          <TableBody>
            <TableRow key="1">
              <TableCell>
                <Checkbox
                  color="success"
                  isSelected={matchDetails?.row1?.selected}
                  onChange={(e) =>
                    handleCheckboxChange("row1", e.target.checked)
                  }
                />
              </TableCell>
              <TableCell>Single</TableCell>
              <TableCell>
                {
                  <Input
                    type="text"
                    placeholder="Enter Rate"
                    name="single_rate"
                    size="sm"
                    variant="bordered"
                    className="w-36 sm:w-full"
                    value={matchDetails?.row1?.rate}
                    readOnly={matchDetails?.row1?.isReadOnly}
                    disabled={!matchDetails?.row1?.selected}
                    onChange={(e) =>
                      handleMatchTypeChange("row1", "rate", e.target.value)
                    }
                  />
                }
              </TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Min Stake"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-36 sm:w-full"
                  value={matchDetails?.row1?.min_stake}
                  readOnly={matchDetails?.row1?.isReadOnly}
                  disabled={!matchDetails?.row1?.selected}
                  onChange={(e) =>
                    handleMatchTypeChange("row1", "min_stake", e.target.value)
                  }
                />
              </TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Max Stake"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-36 sm:w-full"
                  value={matchDetails?.row1?.max_stake}
                  readOnly={matchDetails?.row1?.isReadOnly}
                  disabled={!matchDetails?.row1?.selected}
                  onChange={(e) =>
                    handleMatchTypeChange("row1", "max_stake", e.target.value)
                  }
                />
              </TableCell>
            </TableRow>
            <TableRow key="2">
              <TableCell>
                <Checkbox
                  color="success"
                  isSelected={matchDetails?.row2?.selected}
                  onChange={(e) =>
                    handleCheckboxChange("row2", e.target.checked)
                  }
                />
              </TableCell>
              <TableCell>Single Patti</TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Rate"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-full"
                  value={matchDetails?.row2?.rate}
                  readOnly={matchDetails?.row2?.isReadOnly}
                  disabled={!matchDetails?.row2?.selected}
                  onChange={(e) =>
                    handleMatchTypeChange("row2", "rate", e.target.value)
                  }
                />
              </TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Min Stake"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-full"
                  value={matchDetails?.row2?.min_stake}
                  readOnly={matchDetails?.row2?.isReadOnly}
                  disabled={!matchDetails?.row2?.selected}
                  onChange={(e) =>
                    handleMatchTypeChange("row2", "min_stake", e.target.value)
                  }
                />
              </TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Max Stake"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-full"
                  value={matchDetails?.row2?.max_stake}
                  disabled={!matchDetails?.row2?.selected}
                  readOnly={matchDetails?.row2?.isReadOnly}
                  onChange={(e) =>
                    handleMatchTypeChange("row2", "max_stake", e.target.value)
                  }
                />
              </TableCell>
            </TableRow>
            <TableRow key="3">
              <TableCell>
                <Checkbox
                  color="success"
                  isSelected={matchDetails?.row3?.selected}
                  onChange={(e) =>
                    handleCheckboxChange("row3", e.target.checked)
                  }
                />
              </TableCell>
              <TableCell>Double Patti</TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Rate"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-full"
                  value={matchDetails?.row3?.rate}
                  readOnly={matchDetails?.row3?.isReadOnly}
                  disabled={!matchDetails?.row3?.selected}
                  onChange={(e) =>
                    handleMatchTypeChange("row3", "rate", e.target.value)
                  }
                />
              </TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Min Stake"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-full"
                  value={matchDetails?.row3?.min_stake}
                  readOnly={matchDetails?.row3?.isReadOnly}
                  disabled={!matchDetails?.row3?.selected}
                  onChange={(e) =>
                    handleMatchTypeChange("row3", "min_stake", e.target.value)
                  }
                />
              </TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Max Stake"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-full"
                  value={matchDetails?.row3?.max_stake}
                  readOnly={matchDetails?.row3?.isReadOnly}
                  disabled={!matchDetails?.row3?.selected}
                  onChange={(e) =>
                    handleMatchTypeChange("row3", "max_stake", e.target.value)
                  }
                />
              </TableCell>
            </TableRow>
            <TableRow key="4">
              <TableCell>
                <Checkbox
                  color="success"
                  isSelected={matchDetails?.row4?.selected}
                  onChange={(e) =>
                    handleCheckboxChange("row4", e.target.checked)
                  }
                />
              </TableCell>
              <TableCell>Tripple Patti</TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Rate"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-full"
                  value={matchDetails?.row4?.rate}
                  readOnly={matchDetails?.row4?.isReadOnly}
                  disabled={!matchDetails?.row4?.selected}
                  onChange={(e) =>
                    handleMatchTypeChange("row4", "rate", e.target.value)
                  }
                />
              </TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Min Stake"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-full"
                  value={matchDetails?.row4?.min_stake}
                  readOnly={matchDetails?.row4?.isReadOnly}
                  disabled={!matchDetails?.row4?.selected}
                  onChange={(e) =>
                    handleMatchTypeChange("row4", "min_stake", e.target.value)
                  }
                />
              </TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Max Stake"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-full"
                  value={matchDetails?.row4?.max_stake}
                  readOnly={matchDetails?.row4?.isReadOnly}
                  disabled={!matchDetails?.row4?.selected}
                  onChange={(e) =>
                    handleMatchTypeChange("row4", "max_stake", e.target.value)
                  }
                />
              </TableCell>
            </TableRow>
            <TableRow key="5">
              <TableCell>
                <Checkbox
                  color="success"
                  isSelected={matchDetails?.row5?.selected}
                  onChange={(e) =>
                    handleCheckboxChange("row5", e.target.checked)
                  }
                />
              </TableCell>
              <TableCell>Jodi</TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Rate"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-full"
                  value={matchDetails?.row5?.rate}
                  readOnly={matchDetails?.row5?.isReadOnly}
                  disabled={!matchDetails?.row5?.selected}
                  onChange={(e) =>
                    handleMatchTypeChange("row5", "rate", e.target.value)
                  }
                />
              </TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Min Stake"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-full"
                  value={matchDetails?.row5?.min_stake}
                  readOnly={matchDetails?.row5?.isReadOnly}
                  disabled={!matchDetails?.row5?.selected}
                  onChange={(e) =>
                    handleMatchTypeChange("row5", "min_stake", e.target.value)
                  }
                />
              </TableCell>
              <TableCell>
                <Input
                  type="text"
                  placeholder="Enter Max Stake"
                  name="single_rate"
                  size="sm"
                  variant="bordered"
                  className="w-full"
                  value={matchDetails?.row5?.max_stake}
                  readOnly={matchDetails?.row5?.isReadOnly}
                  disabled={!matchDetails?.row5?.selected}
                  onChange={(e) =>
                    handleMatchTypeChange("row5", "max_stake", e.target.value)
                  }
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table> */}
        <div className="flex justify-end space-x-3">
          <Button color="danger" variant="light" onClick={onCancel}>
            Cancel
          </Button>
          {formData.id ? (
            <Button
              type="button"
              onClick={() => handleUpdateMatch()}
              className="bg-admin_black text-white"
            >
              Update Match
            </Button>
          ) : (
            <Button
              type="button"
              onClick={() => handleSubmit()}
              className="bg-admin_black text-white"
            >
              Save
            </Button>
          )}

          {/* <Button type="submit" className="bg-admin_black text-white">
            Save Match
          </Button> */}
          {/* <Button type="submit" className="bg-admin_black text-white">
              {formData.id ? "Edit Match" : "Add New Match"}Save Match
            </Button> */}
        </div>
      </form>
    </div>
  );
};

export default MatchForm;
